var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#EAF8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81787 8.73573C6.81787 8.43435 6.93759 8.14531 7.1507 7.9322C7.36381 7.71909 7.65285 7.59937 7.95423 7.59937H17.0451C17.3465 7.59937 17.6356 7.71909 17.8487 7.9322C18.0618 8.14531 18.1815 8.43435 18.1815 8.73573V15.5539C18.1815 15.8553 18.0618 16.1443 17.8487 16.3574C17.6356 16.5705 17.3465 16.6903 17.0451 16.6903H7.95423C7.65285 16.6903 7.36381 16.5705 7.1507 16.3574C6.93759 16.1443 6.81787 15.8553 6.81787 15.5539V8.73573Z",
    stroke: "#0076B6",
    strokeWidth: 0.899877,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81812 9.87256L11.08 13.2822C11.4831 13.6047 11.9838 13.7803 12.4999 13.7803C13.0161 13.7803 13.5168 13.6047 13.9198 13.2822L18.1818 9.87256",
    stroke: "#0076B6",
    strokeWidth: 0.899877,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/iconEmail.ab2a8dc4c35e3961c574f53699e514e6.svg";
export { ForwardRef as ReactComponent };